import ShippingAreaDTO from "@/dto/setting/ShippingAreaDTO";
import { getSetting } from "@/services/api/setting/shippingArea";
import { observable, computed, makeObservable, actionBound } from "mobx";

class ShippingAreaStore {
    constructor() {
        makeObservable(this, {
            list: observable,
            loading: observable,
            isInit: observable,
            shippingAreaMap: computed,
            loadList: actionBound,
            addShippingArea: actionBound,
            updateShippingArea: actionBound,
            removeShippingArea: actionBound,
        });
    }

    list: ShippingAreaDTO[] = [];

    loading = false;

    isInit = false;

    get shippingAreaMap() {
        const map = new Map<number, ShippingAreaDTO>();

        for (const shippingArea of this.list) {
            map.set(shippingArea.id, shippingArea);
        }

        return map;
    }

    async loadList() {
        if (this.isInit) {
            return this.list;
        }

        if (this.loading) return [];

        this.loading = true;

        try {
            const dataList = await getSetting();

            this.list = dataList;

            this.isInit = true;
        } finally {
            this.loading = false;
        }

        return this.list;
    }

    addShippingArea(shippingArea: ShippingAreaDTO) {
        this.list.push(shippingArea);
    }

    updateShippingArea(newShippingArea: ShippingAreaDTO) {
        const filterData = this.list.map((shippingArea) => {
            if (shippingArea.id === newShippingArea.id) {
                return newShippingArea;
            }

            return shippingArea;
        });

        this.list = filterData;
    }

    removeShippingArea(id: number) {
        const filterData = this.list.filter((shippingArea) => shippingArea.id !== id);

        this.list = filterData;
    }
}

export default new ShippingAreaStore();
